import Tag from 'antd/lib/tag';
import Tooltip from 'antd/lib/tooltip';
import Typography from 'antd/lib/typography';
import HomeOutlined from '@ant-design/icons/HomeOutlined';
import { ISite } from '../../domain/site/interface';

export interface ISiteTagProps {
    value?: ISite;
}

export const SiteTag = ({ value }: ISiteTagProps) => {
    if (!value?.site_name) return null;

    const { site_name, company } = value;
    const companyName = company?.company_name || '';
    const title = companyName ? `${companyName} / ${site_name}` : site_name;

    return (
        <Tooltip title={title} key={`site-${value.site_id}`} placement="topLeft">
            <Typography className="ellipsis">
                {companyName ? (
                    <Tag color="default" style={{ display: 'initial', position: 'static' }} icon={<HomeOutlined />}>
                        {companyName}
                    </Tag>
                ) : (
                    <></>
                )}
                <Tag color="blue" style={{ display: 'initial', position: 'static', marginRight: 0, padding: '0 4px' }}>
                    Site: {site_name}
                </Tag>
            </Typography>
        </Tooltip>
    );
};
